import React from 'react';
import { SvgIcon } from '@mui/material';
import { ReactComponent as PhoneIcon } from 'mui/assets/icons/phone-icon-24.svg';
import { ReactComponent as PinIcon } from 'mui/assets/icons/pin-on-map.svg';
import { ReactComponent as ClipboardIcon } from 'mui/assets/icons/clipboard-icon.svg';
import {
  StyledClipboardWrapper,
  StyledIconTextWrapper,
  StyledLocationAddress,
  StyledLocationName,
  StyledLocationPhone,
  StyledPhoneLink,
} from './styles';

const DS_LocationContact = ({
  heading,
  phone,
  address,
  withIcons = false,
  withClipBoard = false,
  ellipsis = false,
  isBookingFunnel = false,
  componentH3,
}) => {
  const onClipBoardClick = () => navigator.clipboard.writeText(address);

  return (
    <>
      {heading && (
        <StyledLocationName
          variant={ellipsis ? 'DS_copyMediumBold' : 'DS_copyBigBold'}
          component={componentH3 ? 'h3' : ellipsis ? 'p' : 'h1'}
          className={ellipsis && 'ellipsis'}
        >
          {heading}
        </StyledLocationName>
      )}
      {phone && (
        <StyledIconTextWrapper>
          {withIcons && <SvgIcon component={PhoneIcon} inheritViewBox={true} sx={{ fontSize: 24 }}></SvgIcon>}
          <StyledPhoneLink url={`tel:${phone}`}>
            <StyledLocationPhone variant="DS_copyMediumBold" component="p">
              {phone}
            </StyledLocationPhone>
          </StyledPhoneLink>
        </StyledIconTextWrapper>
      )}
      {process.env.GATSBY_COUNTRY_CODE !== 'de-AT' && address && (
        <StyledIconTextWrapper>
          {withIcons && <SvgIcon component={PinIcon} inheritViewBox={true} sx={{ fontSize: 24 }}></SvgIcon>}
          <StyledLocationAddress
            variant="DS_copyMediumRegular"
            component="p"
            className={ellipsis && 'ellipsis'}
            $isBookingFunnel={isBookingFunnel}
          >
            {address}
          </StyledLocationAddress>
          {withClipBoard && (
            <StyledClipboardWrapper>
              <SvgIcon
                component={ClipboardIcon}
                inheritViewBox={true}
                sx={{ fontSize: 32 }}
                onClick={onClipBoardClick}
              ></SvgIcon>
            </StyledClipboardWrapper>
          )}
        </StyledIconTextWrapper>
      )}
    </>
  );
};

export default DS_LocationContact;
